import { I_PropertyDetail } from "@/shared/models/interfaces/entity/property/property.entity";
import { IUserEntity } from "@/shared/models/interfaces/entity/user/user.entity";
import { CommonOwnerResponseData } from "@/shared/models/interfaces/response/owners/owner-common.interface";
import { get } from "lodash";
import { propertyDetailAdapter } from "../../property/property.adapter.ts/property.adapter";

export const detailCommonOwnerAdapter = (
  data: CommonOwnerResponseData
) => {
  const detail: CommonOwnerDetail = {
    ownerDetail: prepareOwnerDetail(data.owner_details),
    commonProperties: preparePropertyDetail(data.common_properties),
    agentRelationship: prepareAgentRelationship(data.agent_details)
  };

  return detail;
};

const prepareOwnerDetail = (
  data: CommonOwnerResponseData["owner_details"]
) => {
  const detail: any = {};
  get(data, "id") ? (detail.id = data.id) : null;
  get(data, "name") ? (detail.name = data.name) : null;
  get(data, "phone") ? (detail.phone = data.phone) : null;
  get(data, "email") ? (detail.email = data.email) : null;
  return detail as OwnerDetail;
};

const preparePropertyDetail = (
  data: CommonOwnerResponseData["common_properties"]
): I_PropertyDetail[] | [] => {
  const detail: I_PropertyDetail[] | any[] = [];
  if (data?.length > 0) {
    data.forEach(property => detail.push(propertyDetailAdapter(property)));
  }
  return detail;
};

const prepareAgentRelationship = (
  data: CommonOwnerResponseData["agent_details"]
): Partial<IUserEntity> => {
  const obj: Partial<IUserEntity> = {};
  get(data, "id") ? (obj.people_id = data.id) : null;
  get(data, "name") ? (obj.name = data.name) : null;
  get(data, "email") ? (obj.email = data.email) : null;
  get(data, "phone") ? (obj.phone = data.phone) : null;
  get(data, "picture_url") ? (obj.picture = data.picture_url) : null;
  return obj;
};

export interface CommonOwnerDetail {
  ownerDetail: OwnerDetail;
  commonProperties: I_PropertyDetail[];
  agentRelationship: AgentRelationship;
}

interface OwnerDetail {
  id: number;
  name: string | null;
  phone: string | null;
  email: string | null;
}

type AgentRelationship = Partial<IUserEntity>
